import { useSelector } from 'react-redux'

import { RootState } from '../../../reducers'
import { shouldHideSsmlSelector } from '../selectors'

export function useShouldHideSsml() {
  return useSelector<RootState, boolean>(shouldHideSsmlSelector)
}
